import React, { useState } from 'react';
import { string, oneOf } from 'prop-types';
import classnames from 'classnames';
import './style.scss';

const ClientLogo = ({ logoPath, name, size = ClientLogo.SIZES.MEDIUM }) => {
    const [errorLoading, setErrorLoading] = useState(false);
    const classes = classnames('notable-client-logo-wrap', size, { 'hide-on-error': errorLoading });

    const imageError = () => {
        setErrorLoading(true);
    };

    return (
        <div className={classes}>
            <img src={logoPath} alt={name} onError={imageError}/>
        </div>
    );
};

ClientLogo.SIZES = {
    BIG: 'big',
    MEDIUM: 'medium',
    SMALL: 'small'
};

ClientLogo.propTypes = {
    logoPath: string,
    name: string,
    size: oneOf(Object.values(ClientLogo.SIZES))
};

export default ClientLogo;
